// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patient-log-shell,
.patient-log {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #ffffff;
  color: #0F172A;
}

.patient-log-shell > .patient-log {
  flex: 1;
}

.patient-log__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 16px 16px;
  justify-content: flex-start;
  align-content: flex-start;
}

.patient-log__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
  flex-shrink: 0;
}

.patient-log__footer--end {
  justify-content: flex-end;
}

.patient-log__sync {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748B;
}

.patient-log__sync-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #10B981;
}

.patient-log-drawer.ant-drawer .ant-drawer-content-wrapper {
  width: 520px !important;
  max-width: calc(100vw - 32px);
}

.patient-log-drawer .ant-drawer-body {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.patient-log-drawer .ant-drawer-body > * {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.patient-log-drawer .ant-drawer-header {
  display: none;
}

/* Header */
.patient-log-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
  flex-shrink: 0;
}

.patient-log-header__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.patient-log-header__title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}

.patient-log-header__back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #64748B;
  cursor: pointer;
  flex-shrink: 0;
}

.patient-log-header__back:hover {
  background: #F8FAFC;
  color: #0F172A;
}

[dir='rtl'] .patient-log-header__back .anticon {
  transform: scaleX(-1);
}

.patient-log-header__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0F172A;
  line-height: 1.25;
}

.patient-log-header__badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  border: 1px solid #BAE6FD;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.patient-log-header__subrow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.patient-log-header__subtitle {
  margin: 0;
  font-size: 13px;
  color: #64748B;
  line-height: 1.35;
  min-width: 0;
}

.patient-log-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.patient-log-header__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  border: 1px solid transparent;
  white-space: nowrap;
}

.patient-log-header__btn--add {
  border-color: #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.patient-log-header__btn--add:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.patient-log-header__btn--icon {
  width: 32px;
  height: 32px;
  padding: 0;
  border-color: transparent;
  background: transparent;
  color: #94A3B8;
}

.patient-log-header__btn--icon:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.patient-log-header__btn--ghost {
  border-color: #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.patient-log-header__btn--ghost:hover {
  background: #F8FAFC;
  color: #0F172A;
}

/* Menu cards */
.patient-log-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.patient-log-entity-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.12s ease, background 0.12s ease;
}

.patient-log-entity-row:hover {
  border-color: #7DD3FC;
  background: rgba(240, 249, 255, 0.45);
}

.patient-log-entity-row__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.patient-log-entity-row__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #E0F2FE;
  color: #0284C7;
  flex-shrink: 0;
  font-size: 18px;
}

.patient-log-entity-row__icon.is-muted {
  background: #F1F5F9;
  color: #475569;
}

.patient-log-entity-row__text {
  min-width: 0;
}

.patient-log-entity-row__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.patient-log-entity-row__title {
  font-size: 14px;
  font-weight: 600;
  color: #1E293B;
  line-height: 1.25;
}

.patient-log-entity-row:hover .patient-log-entity-row__title {
  color: #0284C7;
}

.patient-log-entity-row__count {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid #A7F3D0;
  background: #ECFDF5;
  color: #047857;
}

.patient-log-entity-row__count.is-pending {
  border-color: #FDE68A;
  background: #FFFBEB;
  color: #B45309;
}

.patient-log-entity-row__desc {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.patient-log-entity-row__chevron {
  color: #94A3B8;
  font-size: 14px;
  flex-shrink: 0;
}

.patient-log-entity-row:hover .patient-log-entity-row__chevron {
  color: #334155;
}

/* Nested section content */
.patient-log .log {
  margin: 0;
  padding: 0 20px 20px;
  overflow-y: auto;
  flex: 1;
  height: auto;
  max-height: none;
}

/* Patient details view */
.patient-log-details__subhead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 20px;
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
  flex-shrink: 0;
}

.patient-log-details__identity {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
}

.patient-log-details__code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 500;
}

.patient-log-details__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  border: 1px solid #A7F3D0;
  background: #ECFDF5;
  color: #059669;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.patient-log-details__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #10B981;
}

.patient-log-details__cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px 20px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.patient-log-card {
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
  padding: 16px;
}

.patient-log-card.is-wash {
  background: #F8FAFC;
}

.patient-log-card.is-alert {
  background: #FFFBEB;
  border-color: #FDE68A;
}

.patient-log-card__head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 10px;
  margin-bottom: 12px;
  border-bottom: 1px solid #E2E8F0;
}

.patient-log-card.is-alert .patient-log-card__head {
  border-bottom: 0;
  margin-bottom: 10px;
  padding-bottom: 0;
}

.patient-log-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #E0F2FE;
  color: #0284C7;
  flex-shrink: 0;
}

.patient-log-card.is-alert .patient-log-card__icon {
  background: #FEF3C7;
  color: #B45309;
}

.patient-log-card__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0F172A;
}

.patient-log-card.is-alert .patient-log-card__title {
  color: #92400E;
  font-weight: 700;
}

.patient-log-profile {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.patient-log-profile__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 9999px;
  border: 1px solid #BAE6FD;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;
}

.patient-log-profile__name {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.25;
}

.patient-log-profile__meta {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: #475569;
}

.patient-log-profile__meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.patient-log-profile__meta-row .anticon {
  color: #64748B;
  font-size: 14px;
}

.patient-log-profile__mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 500;
  color: #0F172A;
}

.patient-log-alert-box {
  border: 1px solid #FDE68A;
  border-radius: 8px;
  background: #ffffff;
  padding: 10px;
  margin-inline-start: 0;
}

.patient-log-alert-box__label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #B45309;
}

.patient-log-alert-box__value {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
}

.patient-log-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.patient-log-field + .patient-log-field {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #E2E8F0;
}

.patient-log-field__label {
  font-size: 13px;
  color: #64748B;
}

.patient-log-field__value {
  font-size: 13px;
  font-weight: 500;
  color: #0F172A;
}

.patient-log-field__value.is-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.patient-log-rx-list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
  background: #F8FAFC;
}

.patient-log-dx-list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
  background: #F8FAFC;
}

.patient-log-dx-form {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #ffffff;
}

.patient-log-dx-toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
  flex-shrink: 0;
}

.patient-log-dx-patient {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.patient-log-dx-patient__main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.patient-log-dx-patient__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #BAE6FD;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.patient-log-dx-patient__meta {
  min-width: 0;
}

.patient-log-dx-patient__name-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
}

.patient-log-dx-patient__name {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patient-log-dx-patient__code {
  font-size: 12px;
  color: #64748B;
  flex-shrink: 0;
}

.patient-log-dx-patient__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
  font-size: 11px;
  color: #059669;
  font-weight: 500;
}

.patient-log-dx-patient__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #10B981;
  flex-shrink: 0;
}

.patient-log-dx-search {
  position: relative;
}

.patient-log-dx-search__icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94A3B8;
  font-size: 15px;
  pointer-events: none;
}

[dir='rtl'] .patient-log-dx-search__icon {
  left: auto;
  right: 12px;
}

.patient-log-dx-search__input {
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  padding: 0 12px 0 36px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #F8FAFC;
  color: #0F172A;
  font-family: inherit;
  font-size: 13px;
  transition: border-color 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
}

[dir='rtl'] .patient-log-dx-search__input {
  padding: 0 36px 0 12px;
}

.patient-log-dx-search__input:focus {
  outline: none;
  background: #ffffff;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.16);
}

.patient-log-dx-search__input::placeholder {
  color: #94A3B8;
}

.patient-log-dx-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.patient-log-dx-filter {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 10px;
  border: 1px solid #E2E8F0;
  border-radius: 9999px;
  background: #ffffff;
  color: #475569;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.patient-log-dx-filter:hover {
  background: #F8FAFC;
  color: #0F172A;
}

.patient-log-dx-filter.is-active {
  border-color: #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
}

.patient-log-dx-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 2px;
}

.patient-log-dx-section__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748B;
}

.patient-log-dx-section__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.patient-log-dx-section__meta {
  font-size: 12px;
  color: #94A3B8;
}

.patient-log-rx-form {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #ffffff;
}

.patient-log-rx-form .rx-form {
  flex: 1;
  min-height: 0;
}

.patient-log-rx-sync {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 8px;
  font-size: 11px;
  color: #64748B;
}

.patient-log-rx-sync__icon {
  color: #059669;
  font-size: 15px;
}

.patient-log__empty {
  padding: 24px 16px;
  text-align: center;
  font-size: 13px;
  color: #64748B;
  border: 1px dashed #E2E8F0;
  border-radius: 12px;
  background: #F8FAFC;
}

/* —— Shared clinical log cards (Follow-ups / Medical tests) —— */
.patient-log-fu-list,
.patient-log-mt-list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
  background: #F8FAFC;
}

.patient-log-fu-form,
.patient-log-mt-form,
.patient-log-pd-form {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #ffffff;
}

.patient-log-fu-form .cl-form,
.patient-log-mt-form .cl-form,
.patient-log-pd-form .cl-form {
  flex: 1;
  min-height: 0;
}

.cl-card {
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.cl-card:hover {
  border-color: #CBD5E1;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
}

.cl-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.cl-card__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.35;
  min-width: 0;
}

.cl-card__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  border: 1px solid transparent;
}

.cl-card__badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
  flex-shrink: 0;
}

.cl-card__badge--recorded {
  background: #E0F2FE;
  border-color: #BAE6FD;
  color: #0284C7;
}

.cl-card__badge--done {
  background: #ECFDF5;
  border-color: #A7F3D0;
  color: #059669;
}

.cl-card__result {
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
}

.cl-card__result-label {
  display: block;
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94A3B8;
}

.cl-card__result-text {
  margin: 0;
  font-size: 13px;
  color: #334155;
  line-height: 1.45;
  white-space: pre-wrap;
}

.cl-card__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 2px;
}

.cl-card__time {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #94A3B8;
}

.cl-card__footer-icon {
  font-size: 12px;
  color: #94A3B8;
}

/* —— Shared clinical log forms —— */
.cl-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  height: 100%;
}

.cl-form__context {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #F8FAFC;
  flex-shrink: 0;
}

.cl-form__context-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.cl-form__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #BAE6FD;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.cl-form__context-name {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.cl-form__context-code {
  font-weight: 400;
  color: #64748B;
  font-size: 11px;
}

.cl-form__context-meta {
  margin: 2px 0 0;
  font-size: 11px;
  color: #64748B;
  line-height: 1.3;
}

.cl-form__context-badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.cl-form__body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.cl-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cl-form__field-label {
  font-size: 13px;
  font-weight: 500;
  color: #334155;
}

.cl-form__required {
  color: #F43F5E;
  margin-inline-start: 2px;
}

.cl-form__input,
.cl-form__textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #0F172A;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.4;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.cl-form__input {
  height: 36px;
  padding: 0 12px;
}

.cl-form__textarea {
  min-height: 96px;
  padding: 10px 12px;
  resize: vertical;
}

.cl-form__textarea--mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
}

.cl-form__input:focus,
.cl-form__textarea:focus {
  outline: none;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.18);
}

.cl-form__hint {
  margin: 0;
  font-size: 11px;
  color: #64748B;
  line-height: 1.35;
}

.cl-form__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
  padding-top: 4px;
  flex-shrink: 0;
}

.cl-form__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  border: 1px solid transparent;
  white-space: nowrap;
}

.cl-form__btn--ghost {
  border-color: #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.cl-form__btn--ghost:hover {
  background: #F8FAFC;
}

.cl-form__btn--primary {
  border-color: #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);
}

.cl-form__btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.cl-form__error {
  margin: 0;
  font-size: 12px;
  color: #DC2626;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowAppointment/components/PatientLog/style.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6EAA6E;EAC7E,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;;EAEE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;EAGE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,cAAc;AAChB","sourcesContent":[".patient-log-shell,\n.patient-log {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  background: #ffffff;\n  color: #0F172A;\n}\n\n.patient-log-shell > .patient-log {\n  flex: 1;\n}\n\n.patient-log__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 12px 16px 16px;\n  justify-content: flex-start;\n  align-content: flex-start;\n}\n\n.patient-log__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n.patient-log__footer--end {\n  justify-content: flex-end;\n}\n\n.patient-log__sync {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.patient-log__sync-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #10B981;\n}\n\n.patient-log-drawer.ant-drawer .ant-drawer-content-wrapper {\n  width: 520px !important;\n  max-width: calc(100vw - 32px);\n}\n\n.patient-log-drawer .ant-drawer-body {\n  padding: 0 !important;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.patient-log-drawer .ant-drawer-body > * {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.patient-log-drawer .ant-drawer-header {\n  display: none;\n}\n\n/* Header */\n.patient-log-header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n.patient-log-header__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.patient-log-header__title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.patient-log-header__back {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #64748B;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.patient-log-header__back:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n[dir='rtl'] .patient-log-header__back .anticon {\n  transform: scaleX(-1);\n}\n\n.patient-log-header__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.patient-log-header__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  border: 1px solid #BAE6FD;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.patient-log-header__subrow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.patient-log-header__subtitle {\n  margin: 0;\n  font-size: 13px;\n  color: #64748B;\n  line-height: 1.35;\n  min-width: 0;\n}\n\n.patient-log-header__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.patient-log-header__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.patient-log-header__btn--add {\n  border-color: #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.patient-log-header__btn--add:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.patient-log-header__btn--icon {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border-color: transparent;\n  background: transparent;\n  color: #94A3B8;\n}\n\n.patient-log-header__btn--icon:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.patient-log-header__btn--ghost {\n  border-color: #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.patient-log-header__btn--ghost:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n/* Menu cards */\n.patient-log-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.patient-log-entity-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px;\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  border-radius: 12px;\n  background: #ffffff;\n  cursor: pointer;\n  transition: border-color 0.12s ease, background 0.12s ease;\n}\n\n.patient-log-entity-row:hover {\n  border-color: #7DD3FC;\n  background: rgba(240, 249, 255, 0.45);\n}\n\n.patient-log-entity-row__left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.patient-log-entity-row__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: #E0F2FE;\n  color: #0284C7;\n  flex-shrink: 0;\n  font-size: 18px;\n}\n\n.patient-log-entity-row__icon.is-muted {\n  background: #F1F5F9;\n  color: #475569;\n}\n\n.patient-log-entity-row__text {\n  min-width: 0;\n}\n\n.patient-log-entity-row__title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.patient-log-entity-row__title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1E293B;\n  line-height: 1.25;\n}\n\n.patient-log-entity-row:hover .patient-log-entity-row__title {\n  color: #0284C7;\n}\n\n.patient-log-entity-row__count {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  border: 1px solid #A7F3D0;\n  background: #ECFDF5;\n  color: #047857;\n}\n\n.patient-log-entity-row__count.is-pending {\n  border-color: #FDE68A;\n  background: #FFFBEB;\n  color: #B45309;\n}\n\n.patient-log-entity-row__desc {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.patient-log-entity-row__chevron {\n  color: #94A3B8;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.patient-log-entity-row:hover .patient-log-entity-row__chevron {\n  color: #334155;\n}\n\n/* Nested section content */\n.patient-log .log {\n  margin: 0;\n  padding: 0 20px 20px;\n  overflow-y: auto;\n  flex: 1;\n  height: auto;\n  max-height: none;\n}\n\n/* Patient details view */\n.patient-log-details__subhead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 20px;\n  background: #F8FAFC;\n  border-bottom: 1px solid #E2E8F0;\n  flex-shrink: 0;\n}\n\n.patient-log-details__identity {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.patient-log-details__code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-weight: 500;\n}\n\n.patient-log-details__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  border: 1px solid #A7F3D0;\n  background: #ECFDF5;\n  color: #059669;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.patient-log-details__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: #10B981;\n}\n\n.patient-log-details__cards {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px 20px 20px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.patient-log-card {\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n  padding: 16px;\n}\n\n.patient-log-card.is-wash {\n  background: #F8FAFC;\n}\n\n.patient-log-card.is-alert {\n  background: #FFFBEB;\n  border-color: #FDE68A;\n}\n\n.patient-log-card__head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-bottom: 10px;\n  margin-bottom: 12px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.patient-log-card.is-alert .patient-log-card__head {\n  border-bottom: 0;\n  margin-bottom: 10px;\n  padding-bottom: 0;\n}\n\n.patient-log-card__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #E0F2FE;\n  color: #0284C7;\n  flex-shrink: 0;\n}\n\n.patient-log-card.is-alert .patient-log-card__icon {\n  background: #FEF3C7;\n  color: #B45309;\n}\n\n.patient-log-card__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.patient-log-card.is-alert .patient-log-card__title {\n  color: #92400E;\n  font-weight: 700;\n}\n\n.patient-log-profile {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.patient-log-profile__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  border-radius: 9999px;\n  border: 1px solid #BAE6FD;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 20px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.patient-log-profile__name {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.patient-log-profile__meta {\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  color: #475569;\n}\n\n.patient-log-profile__meta-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.patient-log-profile__meta-row .anticon {\n  color: #64748B;\n  font-size: 14px;\n}\n\n.patient-log-profile__mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.patient-log-alert-box {\n  border: 1px solid #FDE68A;\n  border-radius: 8px;\n  background: #ffffff;\n  padding: 10px;\n  margin-inline-start: 0;\n}\n\n.patient-log-alert-box__label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #B45309;\n}\n\n.patient-log-alert-box__value {\n  margin-top: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.patient-log-field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.patient-log-field + .patient-log-field {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #E2E8F0;\n}\n\n.patient-log-field__label {\n  font-size: 13px;\n  color: #64748B;\n}\n\n.patient-log-field__value {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.patient-log-field__value.is-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n}\n\n.patient-log-rx-list {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 10px;\n  background: #F8FAFC;\n}\n\n.patient-log-dx-list {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 12px;\n  background: #F8FAFC;\n}\n\n.patient-log-dx-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  background: #ffffff;\n}\n\n.patient-log-dx-toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n.patient-log-dx-patient {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.patient-log-dx-patient__main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.patient-log-dx-patient__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid #BAE6FD;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.patient-log-dx-patient__meta {\n  min-width: 0;\n}\n\n.patient-log-dx-patient__name-row {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  min-width: 0;\n}\n\n.patient-log-dx-patient__name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.patient-log-dx-patient__code {\n  font-size: 12px;\n  color: #64748B;\n  flex-shrink: 0;\n}\n\n.patient-log-dx-patient__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 2px;\n  font-size: 11px;\n  color: #059669;\n  font-weight: 500;\n}\n\n.patient-log-dx-patient__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: #10B981;\n  flex-shrink: 0;\n}\n\n.patient-log-dx-search {\n  position: relative;\n}\n\n.patient-log-dx-search__icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94A3B8;\n  font-size: 15px;\n  pointer-events: none;\n}\n\n[dir='rtl'] .patient-log-dx-search__icon {\n  left: auto;\n  right: 12px;\n}\n\n.patient-log-dx-search__input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 36px;\n  padding: 0 12px 0 36px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #F8FAFC;\n  color: #0F172A;\n  font-family: inherit;\n  font-size: 13px;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;\n}\n\n[dir='rtl'] .patient-log-dx-search__input {\n  padding: 0 36px 0 12px;\n}\n\n.patient-log-dx-search__input:focus {\n  outline: none;\n  background: #ffffff;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.16);\n}\n\n.patient-log-dx-search__input::placeholder {\n  color: #94A3B8;\n}\n\n.patient-log-dx-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.patient-log-dx-filter {\n  display: inline-flex;\n  align-items: center;\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 9999px;\n  background: #ffffff;\n  color: #475569;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.patient-log-dx-filter:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n.patient-log-dx-filter.is-active {\n  border-color: #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n.patient-log-dx-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 0 2px;\n}\n\n.patient-log-dx-section__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.patient-log-dx-section__count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.patient-log-dx-section__meta {\n  font-size: 12px;\n  color: #94A3B8;\n}\n\n.patient-log-rx-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  background: #ffffff;\n}\n\n.patient-log-rx-form .rx-form {\n  flex: 1;\n  min-height: 0;\n}\n\n.patient-log-rx-sync {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding-top: 8px;\n  font-size: 11px;\n  color: #64748B;\n}\n\n.patient-log-rx-sync__icon {\n  color: #059669;\n  font-size: 15px;\n}\n\n.patient-log__empty {\n  padding: 24px 16px;\n  text-align: center;\n  font-size: 13px;\n  color: #64748B;\n  border: 1px dashed #E2E8F0;\n  border-radius: 12px;\n  background: #F8FAFC;\n}\n\n/* —— Shared clinical log cards (Follow-ups / Medical tests) —— */\n.patient-log-fu-list,\n.patient-log-mt-list {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 12px;\n  background: #F8FAFC;\n}\n\n.patient-log-fu-form,\n.patient-log-mt-form,\n.patient-log-pd-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  background: #ffffff;\n}\n\n.patient-log-fu-form .cl-form,\n.patient-log-mt-form .cl-form,\n.patient-log-pd-form .cl-form {\n  flex: 1;\n  min-height: 0;\n}\n\n.cl-card {\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n\n.cl-card:hover {\n  border-color: #CBD5E1;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);\n}\n\n.cl-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.cl-card__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.35;\n  min-width: 0;\n}\n\n.cl-card__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n  border: 1px solid transparent;\n}\n\n.cl-card__badge-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n  flex-shrink: 0;\n}\n\n.cl-card__badge--recorded {\n  background: #E0F2FE;\n  border-color: #BAE6FD;\n  color: #0284C7;\n}\n\n.cl-card__badge--done {\n  background: #ECFDF5;\n  border-color: #A7F3D0;\n  color: #059669;\n}\n\n.cl-card__result {\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n}\n\n.cl-card__result-label {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94A3B8;\n}\n\n.cl-card__result-text {\n  margin: 0;\n  font-size: 13px;\n  color: #334155;\n  line-height: 1.45;\n  white-space: pre-wrap;\n}\n\n.cl-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n.cl-card__time {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #94A3B8;\n}\n\n.cl-card__footer-icon {\n  font-size: 12px;\n  color: #94A3B8;\n}\n\n/* —— Shared clinical log forms —— */\n.cl-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 0;\n  height: 100%;\n}\n\n.cl-form__context {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #F8FAFC;\n  flex-shrink: 0;\n}\n\n.cl-form__context-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.cl-form__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid #BAE6FD;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.cl-form__context-name {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.cl-form__context-code {\n  font-weight: 400;\n  color: #64748B;\n  font-size: 11px;\n}\n\n.cl-form__context-meta {\n  margin: 2px 0 0;\n  font-size: 11px;\n  color: #64748B;\n  line-height: 1.3;\n}\n\n.cl-form__context-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.cl-form__body {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.cl-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cl-form__field-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.cl-form__required {\n  color: #F43F5E;\n  margin-inline-start: 2px;\n}\n\n.cl-form__input,\n.cl-form__textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #0F172A;\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 1.4;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n\n.cl-form__input {\n  height: 36px;\n  padding: 0 12px;\n}\n\n.cl-form__textarea {\n  min-height: 96px;\n  padding: 10px 12px;\n  resize: vertical;\n}\n\n.cl-form__textarea--mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n}\n\n.cl-form__input:focus,\n.cl-form__textarea:focus {\n  outline: none;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.18);\n}\n\n.cl-form__hint {\n  margin: 0;\n  font-size: 11px;\n  color: #64748B;\n  line-height: 1.35;\n}\n\n.cl-form__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: auto;\n  padding-top: 4px;\n  flex-shrink: 0;\n}\n\n.cl-form__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.cl-form__btn--ghost {\n  border-color: #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.cl-form__btn--ghost:hover {\n  background: #F8FAFC;\n}\n\n.cl-form__btn--primary {\n  border-color: #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);\n}\n\n.cl-form__btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.cl-form__error {\n  margin: 0;\n  font-size: 12px;\n  color: #DC2626;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
